/* Copyright (c) 2023 TORITI */

import Request from './request';

export default class SmsCampaignService {
  // ==================== ADMIN APIs ====================

  static async getAdminCampaigns(query = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'GET',
        path: 'admin/sms-campaigns',
        query
      }).then((result = {}) => {
        console.log('SMS Campaign admin list response:', result);

        if (result.success && result.data) {
          return resolve({
            success: true,
            data: result.data.items || result.data,
            pagination: result.pagination || {
              page: query.page || 1,
              pageSize: query.pageSize || 10,
              totalItems: result.data.total_items || 0,
              totalPages: result.data.total_pages || 0
            },
            message: result.message
          });
        }

        return resolve(result);
      }).catch((error) => {
        console.error('SMS Campaign admin list error:', error);
        return resolve({
          success: false,
          errors: [{ message: error.message || 'Failed to fetch SMS campaigns' }]
        });
      });
    });
  }

  static async approveCampaign(campaignId) {
    return new Promise((resolve) => {
      console.log(`Approving SMS campaign: ${campaignId}`);

      Request.send({
        method: 'POST',
        path: `admin/sms-campaigns/${campaignId}/approve`
      }).then((result = {}) => {
        console.log('Approve campaign response:', result);

        if (result.success) {
          return resolve({
            success: true,
            data: result.data,
            message: result.message || 'Campaign approved successfully'
          });
        }

        return resolve(result);
      }).catch((error) => {
        console.error('Approve campaign error:', error);
        return resolve({
          success: false,
          errors: [{ message: error.message || 'Failed to approve campaign' }]
        });
      });
    });
  }

  static async rejectCampaign(campaignId, reason = '') {
    return new Promise((resolve) => {
      console.log(`Rejecting SMS campaign: ${campaignId}`);

      Request.send({
        method: 'POST',
        path: `admin/sms-campaigns/${campaignId}/reject`,
        data: { reason }
      }).then((result = {}) => {
        console.log('Reject campaign response:', result);

        if (result.success) {
          return resolve({
            success: true,
            data: result.data,
            message: result.message || 'Campaign rejected successfully'
          });
        }

        return resolve(result);
      }).catch((error) => {
        console.error('Reject campaign error:', error);
        return resolve({
          success: false,
          errors: [{ message: error.message || 'Failed to reject campaign' }]
        });
      });
    });
  }

  static async markCampaignSent(campaignId) {
    return new Promise((resolve) => {
      console.log(`Marking SMS campaign as sent: ${campaignId}`);

      Request.send({
        method: 'POST',
        path: `admin/sms-campaigns/${campaignId}/mark-sent`
      }).then((result = {}) => {
        console.log('Mark campaign sent response:', result);

        if (result.success) {
          return resolve({
            success: true,
            data: result.data,
            message: result.message || 'Campaign marked as sent successfully'
          });
        }

        return resolve(result);
      }).catch((error) => {
        console.error('Mark campaign sent error:', error);
        return resolve({
          success: false,
          errors: [{ message: error.message || 'Failed to mark campaign as sent' }]
        });
      });
    });
  }

  static async getCampaignById(campaignId) {
    return new Promise((resolve) => {
      Request.send({
        method: 'GET',
        path: `admin/sms-campaigns/${campaignId}`
      }).then((result = {}) => {
        console.log('Campaign detail response:', result);
        return resolve(result);
      }).catch((error) => {
        console.error('Campaign detail error:', error);
        return resolve({
          success: false,
          errors: [{ message: error.message || 'Failed to fetch campaign details' }]
        });
      });
    });
  }
}
